<template>
  <!-- Side bar <i class="fas fa-3x " {{item.icon}}> -->
  <aside class="main-sidebar">
    <section class="sidebar">
      <!-- <ul class="list-unstyled"> -->
      <ul>
        <div>
          <sidebar-menu v-for="(item, index) in sbmenu" :key="index" :item="item">
            <slot slot="dropdown-icon" name="dropdown-icon" />
          </sidebar-menu>
        </div>
      </ul>
    </section>
  </aside>
</template>

<script>
import SidebarMenu from "./SidebarMenu.vue";

const separator = {
  template: '<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">'
};

export default {
  name: "Sidebar",
  data() {
    return {
      sbmenu: [
        { header: true, title: "Links ", hiddenOnCollapse: true },
        {
          header: false,
          href: "/world",
          title: "World",
          // icon: "fa fa-globe-asia"
          icon: '🌏'
        },
        { href: "/india", title: "India", icon: "🇮🇳" },
        { component: separator },
        { header: true, title: "Resources", hiddenOnCollapse: true },
        {
          href: "/dummy",
          title: "Disabled page",
          // icon: "fa fa-lock",
          icon: "🔒",
          disabled: true
        },
        {
          href: "/dummy",
          title: "Badge",
          // icon: "fa fa-cog",
          icon: "📛",
          badge: { text: "Sample", class: "vsm--badge_default" }
        },
        {
          title: "Dropdown Page Sample",
          // icon: "fa fa-list-ul",
          icon: "📑",
          child: [
            {
              href: "/dummy",
              title: "Sub Page 01",
              // icon: "fa fa-file-alt"
              icon: "📝"
            },
            {
              href: "/dummy",
              title: "Sub Page 02",
              // icon: "fa fa-file-alt"
              icon: "📝"
            }
          ]
        },
        // {
        //   title: "1-Multiple Level Sample",
        //   // icon: "fa fa-list-alt",
        //   icon: "👇",
        //   child: [
        //     { title: "2-page", href: "/dummy" },
        //     { title: "2-Menu ",
        //       child: [{ title: "3-page1", href: "/dummy" }, { title: "3-Page2", href: "/dummy" }]
        //     },
        //     { title: "2-Page3", href: "/dummy" },
        //     { title: "2-Another Menu",
        //       child: [
        //         {
        //           title: "3-Level 3",
        //           child: [{ title: "4-Page", href: "/dummy" }, { title: "4-Page", href: "/dummy" }]
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          isToggleButton: true,
          // icon: 'fa fa-hand-o-left',
          icon: "👈",
        },
      ],
      collapsed: false
    };
  },
  components: { SidebarMenu },
  methods: {
    onToggleCollapse(collapsed) {
    //   console.log(collapsed);
      this.collapsed = collapsed;
    },
    onItemClick(event, item) {
    //   console.log("onItemClick");
    //   console.log(event);
    //   console.log(item);
    }
  },
  created() {
  }
};
</script>

<style scopped lang="scss">
.indicon {
  background: url("./../../assets/india.png");
  background-color: green;
  font-size: 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
}
@import "../../scss/Sidebar";
</style>
